import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ISimplifiedCreditCardVerificationRequest,
  ICreditCardVerificationResponse,
} from './credit-card-verification.interface';
import { AlertService } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class CreditCardVerificationService {
  private readonly url =
    '/api/v2/credit_card/credit-card-verification/simplified';

  constructor(
    protected http: HttpClient,
    private alertService: AlertService,
  ) {}

  simplifiedVerification(
    request: ISimplifiedCreditCardVerificationRequest,
  ): Observable<ICreditCardVerificationResponse> {
    return this.http.post<ICreditCardVerificationResponse>(this.url, request);
  }
}
